import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="inline-form"
export default class extends Controller {
  static targets = ["preview", "form", "input"]
  static values = {
    open: Boolean
  }

  connect() {
    this.initialValues = new Map(
      this.inputTargets.map(input => [
        input,
        input.dataset.inlineFormInitialValue ?? input.value
      ])
    )

    this.render()
  }

  show() {
    this.openValue = true
    this.render()
  }

  cancel() {
    this.resetInputs()
    this.openValue = false
    this.render()
  }

  render() {
    this.previewTarget.classList.toggle("hidden", this.openValue)
    this.formTarget.classList.toggle("hidden", !this.openValue)

    if (this.openValue && this.hasInputTarget) {
      this.inputTargets[0].focus()
      this.inputTargets[0].select()
    }
  }

  resetInputs() {
    this.inputTargets.forEach(input => {
      input.value = this.initialValues.get(input)
      input.dispatchEvent(new Event("input", { bubbles: true }))
    })
  }
}
